'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  background: inherit;\n  &&& {\n    padding: ', ';\n    ', ';\n  }\n'], ['\n  background: inherit;\n  &&& {\n    padding: ', ';\n    ', ';\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n            border-bottom-left-radius: inherit;\n            border-bottom-right-radius: inherit;\n          '], ['\n            border-bottom-left-radius: inherit;\n            border-bottom-right-radius: inherit;\n          ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _sizes = require('HubStyleTokens/sizes');

var _PopoverContext = require('../context/PopoverContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Body = _styledComponents2.default.div.withConfig({
  displayName: 'UIPopoverBody__Body'
})(_templateObject, function (_ref) {
  var popoverUse = _ref.popoverUse;
  return popoverUse === 'shepherd' ? _sizes.SHEPHERD_PADDING_Y + ' ' + _sizes.POPOVER_PADDING_X : null;
}, function (_ref2) {
  var popoverUse = _ref2.popoverUse;
  return popoverUse === 'shepherd' ? (0, _styledComponents.css)(_templateObject2) : null;
});

function UIPopoverBody(_ref3) {
  var children = _ref3.children,
      className = _ref3.className,
      flush = _ref3.flush,
      popoverContext = _ref3.popoverContext,
      rest = _objectWithoutProperties(_ref3, ['children', 'className', 'flush', 'popoverContext']);

  return _react2.default.createElement(
    Body,
    _extends({}, rest, {
      className: (0, _classNames2.default)('uiPopoverBody', 'private-popover__body', { 'private-popover__body--flush': flush }, className),
      popoverUse: popoverContext.use
    }),
    children
  );
}

UIPopoverBody.propTypes = {
  children: _react.PropTypes.node,

  flush: _react.PropTypes.bool,
  popoverContext: _PopoverContext.popoverContextPropType
};

UIPopoverBody.displayName = 'UIPopoverBody';

exports.default = (0, _PopoverContext.ConsumesPopoverContext)(UIPopoverBody);
module.exports = exports['default'];